module.exports = __webpack_public_path__ + "img/replay.a440237c.png";